import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const editarFaixaNavegacao = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put('/faixaNavegacao/editar', params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const obterFaixaNavegacao = async (id: number) => {
  try {
    const response = await api.get(`/faixaNavegacao/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter faixa de navegação';
    throw new Error(errorMessage);
  }
};

export const listarFaixaNavegacao = async () => {
  try {
    const response = await api.get(`/faixaNavegacao/listar`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar faixa de navegação';
    throw new Error(errorMessage);
  }
};

export const paginasAtivas = async () => {
  try {
    const response = await api.get('/paginas/ativas');
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar páginas ativas';
    throw new Error(errorMessage);
  }
};

export const deletarFaixaDeNavegacao = async (id: any) => {
  try {
    const headers = {
      'Accept': '*/*'
    };
    const response = await api.delete(`/faixaNavegacao/${id}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};
